import { obterPeriodosFiltro, periodoInclui } from './functions.js'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} equipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  equipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const especificas = item.num_acoes_inter_prof == 0

      if (!mes) {
        return especificas
      }

      const periodos = obterPeriodosFiltro(mes)

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) === 0 &&
          periodoInclui(periodos, dado.nu_mes, dado.nu_ano) &&
          equipe.ine_emulti == dado.nu_ine
        )
      })

      return especificas && !!registroMes
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const acoes = item.num_acoes_inter_prof > 0

      if (!mes) {
        return acoes
      }

      const periodos = obterPeriodosFiltro(mes)

      let dados = []

      try {
        dados =
          typeof item.dados === 'string'
            ? JSON.parse(item.dados)
            : item.dados || []
      } catch (e) {
        dados = []
      }

      const registroMes = dados.find((dado) => {
        return (
          Number(dado.nm) != 0 &&
          periodoInclui(periodos, dado.nu_mes, dado.nu_ano) &&
          equipe.ine_emulti == dado.nu_ine
        )
      })

      return acoes && !!registroMes
    })
  }

  return cadastros_filtrados
}
